import { render } from "./ColapseButton.vue?vue&type=template&id=4d7709a2"
import script from "./ColapseButton.vue?vue&type=script&lang=js"
export * from "./ColapseButton.vue?vue&type=script&lang=js"

import "./ColapseButton.vue?vue&type=style&index=0&id=4d7709a2&lang=scss"

import exportComponent from "/builds/linkbuilding-crm/crm-v2-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__